import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  iconContainer: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    background: "#6FA088",
    borderRadius: theme.spacing(1),
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
}));

export default useStyles;
